/*
 * Filename: d:\projects\AutoFiFront\src\Theme\FilterIconReset.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Tuesday, February 14th 2023, 2:53:17 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const FilterIconReset = styled.div.attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
cursor: pointer;
color: ${(props: any) => getThemeColor(props.bgColor)};
`;

export default FilterIconReset;
